import { apiClient } from '../services/api';

const SHOP_DOMAIN_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9-]*\.myshopify\.com$/;

export const normalizeShopDomain = (input: string): string => {
  const trimmed = input.trim().toLowerCase().replace(/^https?:\/\//, '').replace(/\/.*$/, '');
  if (!trimmed) return '';
  if (trimmed.endsWith('.myshopify.com')) return trimmed;
  if (trimmed.includes('.')) return trimmed;
  return `${trimmed}.myshopify.com`;
};

export const isValidShopDomain = (shop: string): boolean => SHOP_DOMAIN_REGEX.test(shop);

export const startShopifyInstall = async (rawShop: string): Promise<void> => {
  const shop = normalizeShopDomain(rawShop);
  if (!isValidShopDomain(shop)) {
    throw new Error('Enter a valid Shopify store domain like your-store.myshopify.com');
  }

  const response = await apiClient.get('/shopify/auth', { params: { shop } });
  const authUrl = response.data?.data?.authUrl || response.data?.authUrl;
  if (!authUrl) {
    throw new Error('Could not start Shopify install. Please try again.');
  }
  window.location.href = authUrl;
};
